import React, { useState, useEffect } from 'react';
import { fetchUserProfile } from '../api.js';
import Cookies from 'js-cookie';

function Profile() {
  const [profile, setProfile] = useState({
    username: '',
    email: '',
  });
  const [status, setStatus] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      const userId = Cookies.get('userId');
      if (!userId) {
        setStatus('Unauthorized. Please log in.');
        return;
      }

      try {
        console.log("Fetching user profile...");
        const response = await fetchUserProfile();
        console.log('Full response:', response);
        console.log('Response data:', response.data);

        if (response.data.username && response.data.email) {
          console.log('step 2');
          setProfile({
            username: response.data.username,
            email: response.data.email,
          });
          console.log('Username:', response.data.username);
          console.log('Email:', response.data.email);
        } else {
          setStatus('Failed to load profile data.');
          console.error('Profile data is missing username or email.');
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          setStatus('Unauthorized. Please log in.');
        } else {
          setStatus('An error occurred while fetching your profile.');
        }
        console.error('Fetch error:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>Your Profile</h1>

      {status && <div style={{ marginTop: '20px', color: 'red' }}>{status}</div>}

      <div style={{ marginBottom: '15px' }}>
        <label><strong>Username:</strong></label>
        <input
          type="text"
          value={profile.username}
          readOnly
          style={{ padding: '8px', marginTop: '5px', border: '1px solid #ccc', width: '100%' }}
        />
      </div>

      <div style={{ marginBottom: '15px' }}>
        <label><strong>Email:</strong></label>
        <input
          type="text"
          value={profile.email}
          readOnly
          style={{ padding: '8px', marginTop: '5px', border: '1px solid #ccc', width: '100%' }}
        />
      </div>

      <div style={{ marginBottom: '15px' }}>
        <a href="/forgot-password" style={{ color: '#007BFF', textDecoration: 'underline' }}>
          Forgot your password? Click here to reset it via email.
        </a>
      </div>
    </div>
  );
}

export default Profile;
